import { PermisoDetalle, PermisoDetalleForm } from '@models/.';

export function transformToData(permissionDetail: PermisoDetalle | null): PermisoDetalle | null {
  if (!permissionDetail) return null;
  
  return {
    ...permissionDetail,
  };
}

export function transformToForm(permissionDetail: PermisoDetalle): PermisoDetalleForm | null {
  if (!permissionDetail) return null;
  
  const {
    id,
    nombre: name,
    fechaCreacion: creationDate,
    fechaActualizacion: updateDate,
  } = permissionDetail;
  
  return {
    id,
    name,
    creationDate,
    updateDate,
  };
}